exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".App{text-align:center;display:flex;flex-grow:1}.App .App-logo{animation:App-logo-spin infinite 200s linear;height:80px}.App .App-header{background-color:#222;height:150px;padding:20px;color:#fff}.App .App-intro{font-size:large}@keyframes App-logo-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}#root,body,html{height:100%}div.Toolbar{background-color:#fff!important}div.Toolbar *{color:#000!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/App.scss
// module id = 275
// module chunks = 0